export default __webpack_public_path__ + "7cdd74eaca6c414366c848106250f761.svg";